import React from "react";
import { SERVICES_ONE_LIST } from "../../mocks/services";
import { ServiceOneItem } from "./ServiceOneItem";

export const ServiceFive = () => {
  return (
    <section className="services-area-five inner-services-bg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8 col-md-10">
            <div className="section-title-two text-center mb-50">
              <h2 className="title">
              Which Bookkeeping Service Do You Need?
              </h2>
              <p>Silverwave offers six bookkeeping services for startups and small businesses in Surrey, 
                Delta, Langley and White Rock. Not sure which one fits? Book a free 20-minute health check 
                and we'll tell you.</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {SERVICES_ONE_LIST.map((service) => (
            <div key={service.id} className="col-lg-4 col-md-6 col-sm-10">
              <ServiceOneItem service={service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
